import React from 'react';
import styled from 'styled-components';
import Spacer from './Spacer';

const Container = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

const LabelContainer = styled.div``;

const Title = styled.div`
  font-weight: 500;
  font-size: 15px;
  margin-bottom: 5px;
`;

const Subtitle = styled.div`
  color: #6f7093;
  font-size: 14px;
  font-weight: 400;
`;

const Content = styled.div`
  font-size: 14px;
  font-weight: 400;
`;

type Props = {
  title: string;
  description: string;
  children: React.ReactNode;
};

export default function RowLabel({ title, description, children }: Props) {
  return (
    <Container>
      <LabelContainer>
        <Title>{title}</Title>
        <Subtitle>{description}</Subtitle>
      </LabelContainer>
      <Spacer vertical spacing={2} />
      <Content>{children}</Content>
    </Container>
  );
}
